var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.27,
    height: 22.559,
    viewBox: "0 0 21.27 22.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "login",
    d: "M10.247,20.69V11.036L6.742,14.542a.967.967,0,1,1-1.367-1.369l5.156-5.155a.967.967,0,0,1,1.368,0l5.156,5.155a.967.967,0,1,1-1.367,1.369l-3.505-3.507V20.69c0,.32-.433.58-.967.58S10.247,21.01,10.247,20.69Zm10.378-6.08V3.38a1.64,1.64,0,0,0-1.611-1.662H3.545A1.641,1.641,0,0,0,1.933,3.38V14.61a.918.918,0,0,1-.967.859A.918.918,0,0,1,0,14.61V3.38A3.462,3.462,0,0,1,3.545,0H19.014a3.463,3.463,0,0,1,3.545,3.38V14.61a.974.974,0,0,1-1.934,0Z",
    transform: "translate(21.27) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.15b5b2ef9556c4b7e926a96fd2af5c6e.svg";
export { ForwardRef as ReactComponent };